import { APIServiceBilling } from "../api/billing";
import { APIServiceFeedbackDashboard } from "../api/feedback-dashboard";
import { APIServiceFeedbackFile } from "../api/feedback-file";
import { APIServiceFeedback } from "../api/feedback";
import { APIServicePropertyAlert } from "../api/property-alert";
import { APIServiceProperty } from "../api/property";
import { APIServiceSubscription } from "../api/subscription";
import { APIServiceUser } from "../api/user";

export default {
  APIServiceBilling,
  APIServiceFeedbackDashboard,
  APIServiceFeedbackFile,
  APIServiceFeedback,
  APIServicePropertyAlert,
  APIServiceProperty,
  APIServiceSubscription,
  APIServiceUser
};
